import { createContext } from 'react';

import { SearchDomainConfigProviderValue } from './SearchDomainConfigProvider.types.ts';

export const SearchDomainConfigProviderContext = createContext<SearchDomainConfigProviderValue | undefined>(undefined);

export const SearchDomainConfigProvider = SearchDomainConfigProviderContext.Provider;
